export const popoverTheme = {
  padding: '12px 12px 0 12px',
};
